import { APP_INITIALIZER } from '@angular/core';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { throwIfAlreadyLoaded } from './helpers/module-import-guard';
import { TemplateModule } from './template/template.module';
import { ToastModule } from './toast/toast.module';
import { HttpModule, Http } from '@angular/http';
import { SecurityModule } from './security/security.module';
import { ConfigService } from './config/config.service';
import { ConfigLoaderService } from './config/config-loader.service';
import { ModalModule } from './modal/modal.module';
import { LoadingBarModule } from './loading-bar/loading-bar.module';
import { ServerNotificationModule } from './server-notification/server-notification.module';
import { ServerListenersModule } from './server-listeners/server-listeners.module';
import { GaActivitiesService } from './google-analytics/ga-activities.service';


@NgModule({
  imports: [
    HttpModule, CommonModule, FormsModule, RouterModule, TemplateModule,
    ToastModule, SecurityModule, ModalModule, LoadingBarModule,
    ServerNotificationModule, ServerListenersModule
  ],
  exports: [
    HttpModule, CommonModule, FormsModule, RouterModule, TemplateModule,
    ToastModule, SecurityModule, ModalModule, LoadingBarModule,
    ServerNotificationModule, ServerListenersModule
  ],
  declarations: [],
  providers: [
    ConfigService,
    GaActivitiesService,
    ConfigLoaderService,
    { provide: APP_INITIALIZER, useFactory: initConfiguration, deps: [ConfigLoaderService], multi: true }
  ]
})
export class CoreModule {
  constructor( @Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}

export function initConfiguration(configService: ConfigLoaderService): Function {
  return () => configService.load();
}




// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/core.module.ts